import { mainIconSize } from '@/constants';
import { Button } from '@nautilusbio/nb-design-system/Button';
import { Group } from '@nautilusbio/nb-design-system/Group';
import { Stack } from '@nautilusbio/nb-design-system/Stack';
import { Text } from '@nautilusbio/nb-design-system/Text';
import { Loader, Save, X } from 'lucide-react';
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import pageStyles from '../../../../styles/pages/index.module.css';
import styles from '../styles.module.css';

type CreateOrgActionsProps = {
  onCancel: () => void;
  onSubmit: () => void;
  isSubmitting: boolean;
  canSubmit: boolean;
  errorMessage?: string | null;
  name?: string;
};

function CreateOrgActionsComponent({
  onCancel,
  onSubmit,
  isSubmitting,
  canSubmit,
  errorMessage,
  name = '',
}: CreateOrgActionsProps) {
  const { t } = useTranslation('orgs');

  return (
    <Stack className={pageStyles.titleRow} alignItems="center" justifyContent="space-between" orientation="horizontal">
      <Text as="h2">{t('create_org_title')}</Text>
      <Group justifyContent="flex-end">
        <Button data-testid="cancel-btn" isDisabled={isSubmitting} onPress={onCancel} type="button" visual="danger">
          <X size={mainIconSize} />
          {t('create_org_cancel')}
        </Button>
        <Button
          data-testid="submit-btn"
          isDisabled={!canSubmit || isSubmitting}
          type="button"
          onPress={onSubmit}
          visual={isSubmitting ? 'primary' : 'success'}
        >
          {isSubmitting ? (
            <>
              <Loader size={mainIconSize} />
              {t('create_org_creating', { name })}
            </>
          ) : (
            <>
              <Save size={mainIconSize} />
              {t('create_org_submit')}
            </>
          )}
        </Button>
      </Group>
      {errorMessage && <Text className={styles.errorText}>{errorMessage}</Text>}
    </Stack>
  );
}

export const CreateOrgActions = memo(CreateOrgActionsComponent);
